import React from 'react';
import { Button, Tooltip, Tag, Tabs } from 'antd';

import CustomTable from '../../../components/CustomTable';
const { TabPane } = Tabs;

export default function ResultList(props) {
    return (
        <div className="row">
            <div className="col-md-12 form-group">
                <Tabs
                    activeKey={props.formValues.activeKey}
                    onChange={(key) => props.onChangeTab(key)}
                >
                    <TabPane tab="Detalle de Atributos" key="1">
                        <CustomTable
                            loadingExcel={props.loadingExcel}
                            loadingPdf={props.loadingPdf}
                            loadingPrint={props.loadingPrint}
                            onExportExcel={props.onExportExcel}
                            onExportPdf={props.onExportPdf}
                            onPrint={props.onPrint}
                            onChange={props.onChange}
                            pagination={props.pagination}
                            rowKey={record => record.id}
                            columns={[
                                {
                                    title: 'Opciones',
                                    key: 'options',
                                    align: 'center',
                                    render: (value, row) => (
                                        <div className="custom-options">
                                            <Tooltip placement="top" title={"Editar"}>
                                                <Button
                                                    disabled={!row.flag}
                                                    type="primary"
                                                    icon="edit"
                                                    size={"small"}
                                                    onClick={() => props.onEdit(row)}
                                                />
                                            </Tooltip>
                                            <Tooltip placement="top" title={row.flag ? "Deshabilitar" : "Habilitar"}>
                                            <Button
                                                    type={row.flag ? "danger" : "success"}
                                                    icon={row.flag ? "close" : "check"}
                                                    size={"small"}
                                                    onClick={() => props.onDeleteActive(row)}
                                                />
                                            </Tooltip>
                                        </div>
                                    )
                                },
                                {
                                    title: 'Nombre',
                                    dataIndex: 'nombre',
                                    key: 'nombre',
                                    sorter: true
                                },
                                {
                                    title: 'Tipo Campo',
                                    dataIndex: 'tipoCampo',
                                    key: 'tipoCampo',
                                    sorter: true
                                },
                                {
                                    title: 'Opciones',
                                    dataIndex: 'item',
                                    key: 'item',
                                    sorter: true
                                },
                                {
                                    title: 'Estado',
                                    dataIndex: 'flag',
                                    key: 'flag',
                                    align: 'center',
                                    render: (value) => {
                                        return (<div className="custom-options" >
                                            <Tag color={value ? "green" : "red"}>{value ? "Activo" : "Inactivo"}</Tag>
                                        </div>)
                                    }
                                }
                            ]}
                        />
                    </TabPane>
                    <TabPane tab="Detalle de Variantes" key="2">
                        <CustomTable
                            loadingExcel={props.loadingExcel}
                            loadingPdf={props.loadingPdf}
                            loadingPrint={props.loadingPrint}
                            onExportExcel={props.onExportExcel}
                            onExportPdf={props.onExportPdf}
                            onPrint={props.onPrint}
                            onChange={props.onChange}
                            pagination={props.pagination}
                            rowKey={record => record.id}
                            columns={[
                                {
                                    title: 'Opciones',
                                    key: 'options',
                                    align: 'center',
                                    render: (value, row) => (
                                        <div className="custom-options">
                                            <Tooltip placement="top" title={"Editar"}>
                                                <Button
                                                    disabled={!row.flag}
                                                    type="primary"
                                                    icon="edit"
                                                    size={"small"}
                                                    onClick={() => props.onEdit(row)}
                                                />
                                            </Tooltip>
                                            <Tooltip placement="top" title={row.flag ? "Deshabilitar" : "Activar"}>
                                                <Button
                                                    type={row.flag ? "danger" : "success"}
                                                    icon={row.flag ? "close" : "check"}
                                                    size={"small"}
                                                    onClick={() => props.onDeleteActive(row)}
                                                />
                                            </Tooltip>
                                        </div>
                                    )
                                },
                                {
                                    title: 'Nombre',
                                    dataIndex: 'nombre',
                                    key: 'nombre',
                                    sorter: true
                                },
                                {
                                    title: 'Tipo Campo',
                                    dataIndex: 'tipoCampo',
                                    key: 'tipoCampo',
                                    sorter: true
                                },
                                {
                                    title: 'Opciones',
                                    dataIndex: 'item',
                                    key: 'item',
                                    sorter: true
                                },
                                {
                                    title: 'Estado',
                                    dataIndex: 'flag',
                                    key: 'flag',
                                    align: 'center',
                                    render: (value) => {
                                        return (<div className="custom-options" >
                                            <Tag color={value ? "green" : "red"}>{value ? "Activo" : "Inactivo"}</Tag>
                                        </div>)
                                    }
                                }
                            ]}
                        />
                    </TabPane>


                </Tabs>
            </div>
        </div>
    );
}